import React, { useState } from 'react';
import { useTimer } from 'react-timer-hook';
import './Timer.css';

const Timer = ({ onTimerExpired, style }) => {
    const [resetMinutes, setMinutes] = useState(10);
    const [resetSeconds, setSeconds] = useState(0);

    let totalSeconds = resetMinutes * 60 + resetSeconds;
    let expireTimestamp = new Date();
    expireTimestamp.setSeconds(expireTimestamp.getSeconds() + totalSeconds);

    const restartTimer = () => {
        let timer = new Date();
        timer.setSeconds(timer.getSeconds() + totalSeconds);
        restart(timer);
        if (!isRunning) pause();
    };

    const onExpire = () => {
        onTimerExpired();
        restartTimer();
    };

    const setTime = (event, func) => {
        func(Math.max(parseInt(event.target.value), 0));
    };

    const {
        seconds, minutes, isRunning, pause, resume, restart,
    } = useTimer({ expiryTimestamp: expireTimestamp, onExpire: onExpire, autoStart: false });

    return (
        <div className="timer-container" style={style}>
            <div className="timer-display alert alert-info text-center mb-0 pt-0 pb-0">
                <span>{String(minutes).padStart(2, '0')}</span>
                :
                <span>{String(seconds).padStart(2, '0')}</span>
            </div>
            <div className="btn-group px-0 py-0" style={{ width: '100%' }}>
                <button className="btn btn-dark"
                    style={{ width: '10%', background: isRunning ? '#04539E' : '#8FB9E4' }}
                    onClick={isRunning ? pause : resume}>
                    {isRunning ? '\u23F8' : '\u23F5'}
                </button>
                <button className="btn btn-dark" style={{ width: '10%', background: "#1A3357" }}
                    onClick={restartTimer}>
                    {"\u21B6"}
                </button>
            </div>
            <div className="timer-settings h6">
                Timer Settings:
            </div>
            <div className="timer-settings-inputs h6">
                <input
                    type="number"
                    value={resetMinutes}
                    onChange={(event) => setTime(event, setMinutes)}
                    style={{ fontSize: '0.9rem', width: '60px' }}
                /> M&nbsp;
                <input
                    type="number"
                    value={resetSeconds}
                    onChange={(event) => setTime(event, setSeconds)}
                    style={{ fontSize: '0.9rem', width: '60px' }}
                /> S
            </div>
        </div>
    );
};

export default Timer;
